import React from 'react';
import { Box, Typography, Button, Container, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import GppBadIcon from '@mui/icons-material/GppBad';
import LockIcon from '@mui/icons-material/Lock';

import useStore from '../store/useStore';
import { translations } from '../translations';

export default function UnauthorizedPage() {
  const { language } = useStore();
  const t = translations[language];
  const navigate = useNavigate();

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          textAlign: 'center',
        }}
      >
        <Paper
          elevation={6}
          sx={{
            p: 8,
            borderRadius: 6,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            boxShadow: '0 20px 50px rgba(0,0,0,0.1)',
          }}
        >
          <Box sx={{ position: 'relative', mb: 4 }}>
            <GppBadIcon
              sx={{ fontSize: 100, color: 'error.light', opacity: 0.2 }}
            />
            <LockIcon
              sx={{
                fontSize: 40,
                color: 'error.main',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
              }}
            />
          </Box>
          <Typography
            variant="h3"
            sx={{ fontWeight: 800, mb: 2, color: 'text.primary' }}
          >
            {t.accessDenied}
          </Typography>
          <Typography
            variant="h6"
            color="text.secondary"
            sx={{ mb: 6, maxWidth: 450 }}
          >
            {language === 'en'
              ? 'You do not have the necessary permissions to view this area of the portal. Please contact your administrator if you believe this is an error.'
              : 'У вас нет необходимых прав для просмотра этого раздела портала. Пожалуйста, свяжитесь с администратором, если вы считаете, что это ошибка.'}
          </Typography>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button
              variant="outlined"
              size="large"
              onClick={() => navigate(-1)}
              sx={{ borderRadius: 3, px: 4 }}
            >
              {language === 'en' ? 'Go Back' : 'Назад'}
            </Button>
            <Button
              variant="contained"
              size="large"
              color="primary"
              onClick={() => navigate('/')}
              sx={{ borderRadius: 3, px: 4 }}
            >
              {t.dashboard}
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
}
